import { IEventData } from 'meta/pages/v4/event'
import { IWalletEvent } from 'meta/pages/v4/wallet'

import { useEventData } from 'hooks/useEvent'

import { WalletTicketDesktopSkeleton } from '../../WalletTickets/WalletTicketDesktop'
import WalletExtraDesktop from './WalletExtraDesktop'

type EventProps = {
  isPastEvent?: boolean
  isUsable?: boolean
  walletEventData: IWalletEvent
  setIsThereAtLeastOne?(isThereAtLeastOne: boolean): void
}

export type WalletExtraDesktopProps = {
  baseProps: EventProps
  eventData: IEventData
}

const WalletExtraDesktopContainer: React.FC<EventProps> = (props) => {
  const { walletEventData } = props

  const eventData = useEventData({ idOrCodeUrl: String(walletEventData.id) })

  if (!eventData) {
    return <WalletTicketDesktopSkeleton />
  }

  return <WalletExtraDesktop eventData={eventData} baseProps={props} />
}

export default WalletExtraDesktopContainer
